module.exports = __webpack_public_path__ + "static/property-custom-build-lots-macromenu-ad6f589f1276fad73399f458b5befc1f.jpg";